<template>
  <div id="app">
    <!-- <Header @reload="reload"></Header> -->
    <router-view class="router" v-if="loadRouter" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { simpleRpcProvider } from '@/utils/provider';
import Header from '@/components/Header.vue';
import BottomNavigation from '@/components/BottomNavigation.vue';
import Sidebar from '@/components/Sidebar.vue';
import { Toast } from 'vant';
export default {
  name: 'App',
  data() {
    return {
      loadRouter: true,
    };
  },
  components: {
    Header,
    BottomNavigation,
    Sidebar,
  },
  beforeCreate() {
    let token = this.$route.query.token;
    if (token) {
      localStorage.setItem('website', 'app');
      localStorage.setItem('account', this.$route.query.mobile);
      localStorage.setItem('token__' + this.$route.query.mobile, token);
      this.$store.commit('SETACCOUNTS', this.$route.query.mobile);
    }
    this.$store.dispatch('setWebProvider');
    // localStorage.setItem('lang', "zh-CN");
  },
  computed: {
    ...mapState(['account', 'provider', 'gasPrice', 'slippage', 'deadline', 'transactions', 'block', 'expert']),
  },
  async created() {
    const blockNumber = await simpleRpcProvider.eth.getBlockNumber();
    this.$store.commit('SETBLOCK', blockNumber);
    this.timer = setInterval(async () => {
      const blockNumber = await simpleRpcProvider.eth.getBlockNumber();
      this.$store.commit('SETBLOCK', blockNumber);
    }, 6000);
    // window.__lastPath__ = window.location.pathname;

    window.addEventListener('popstate', function (e) {
      const currentPath = window.location.pathname;
      console.log('popstate 触发了');
      // console.log("当前路径111",currentPath);
      console.log('上一个路径222', window.__lastPath__);
      // Toast({ message: currentPath });
      let a = window.__lastPath__ == '/' || window.__lastPath__ == '/mine' || window.__lastPath__ == '/teaTalk' || window.__lastPath__ == '/transfer' || window.__lastPath__ == '/storage';
      // Toast({ message: '当前路径111' + window.__currentPath__ + '上一个路径：' + window.__lastPath__ +"a"+a});
      if (window.__lastPath__ == '/' || window.__lastPath__ == '/mine' || window.__lastPath__ == '/teaTalk' || window.__lastPath__ == '/transfer' || window.__lastPath__ == '/storage') {
        // 通知 App 返回
        // Toast({ message: "触发了退出小程序" });
        console.log('退出小程序');
        wx.miniProgram.postMessage({ data: {foo: 'bar'} })
        return wx.miniProgram.switchTab({ url: '/pages/index/index' });
      }
    });
  },
  watch: {
    block() {
      this.handleUpdateTransactions();
    },
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
  methods: {
    async handleUpdateTransactions() {
      if (!this.account) {
        return;
      }
      const allTransactions = Object.values(this.transactions);
      const pendTransactions = allTransactions.filter(item => {
        return !item.receipt && item.from.toLowerCase() == this.account.toLowerCase();
      });
      pendTransactions.forEach((item, index) => {
        simpleRpcProvider.eth.getTransactionReceipt(item.hash).then(receipt => {
          if (receipt) {
            this.$store.commit('SETTRANSACTIONSRECEIPT', {
              hash: item.hash,
              receipt,
            });
            if (document.documentElement.clientWidth < 400) {
              if (receipt.status) {
                this.$message({ type: 'success', title: item.title, message: item.message, hash: receipt.hash });
              } else {
                this.$message({ type: 'error', title: item.title, message: item.message, hash: receipt.hash });
              }
            } else {
              if (receipt.status) {
                this.$message({
                  position: 'top-right',
                  type: 'success',
                  title: item.title,
                  message: item.message,
                  hash: receipt.hash,
                });
              } else {
                this.$message({
                  position: 'top-right',
                  type: 'error',
                  title: item.title,
                  message: item.message,
                  hash: receipt.hash,
                });
              }
            }
          }
        });
      });
    },
    async reload() {
      this.loadRouter = false;
      this.$nextTick(() => {
        this.loadRouter = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  // font-family: Roboto, Segoe UI, sans-serif;
  font-family: 'PingFang';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  // background: #091224;
  // height: 100%;
  image-rendering: -webkit-optimize-contrast;
  .router {
  }
}
</style>
